import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Thank you, {{name}}',
    confirmation_email:
      'You’ll get a confirmation email with your order number soon to your E-Mail by our Tech-Partner {{provider_email}}',
    need_help: 'Need help?',
  },
  labels: {
    order_number: 'Order Nr: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Today',
    was_prefix: 'was',
    restaurant: 'Restaurant',
    order_details: 'Order details',
    your_details: 'Your details',
    contact: 'Contact',
    payment: 'Payment',
    payment_method: 'Payment method',
    delivery: 'Delivery',
    delivery_details: 'Delivery details',
    pickup_details: 'Pickup details',
    pickup_instruction: '📋 Tell us your order number {{number}} when you pick up your order.',
    billing_info: 'Billing information',
    order_summary: 'Order summary',
    help: 'Need help? Contact us {{phone_number}}',
  },
  status: {
    canceled: 'Order canceled',
    received: 'Order received',
    confirmed: 'Order confirmed!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Pickup',
    [ORDER_METHODS.DELIVERY]: 'Delivery',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Table service',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(room #{{details}})',
    [RoomServiceLocationType.TableService]: '(table #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Points earned',
      from_order: 'points from this order',
      total_balance: 'Total balance',
      reward_value: 'Reward value',
      redeem_hint: '✓ You can redeem up to {{points}} pts ({{amount}}) on your next order',
      points_to_redeem: 'You only need {{points}} more points to redeem your reward',
    },
    guest: {
      pill_title: 'Rewards',
      earned_heading: 'You earned <highlight>{{points}} points</highlight> on this order',
      worth_on_next: 'Worth <strong>{{amount}}</strong> on your next order',
      ready_to_claim: 'Ready to claim',
      next_order_discount: 'Next order discount',
      claim_cta: 'Claim your {{points}} pts — sign up free',
      claim_note: 'Takes 30 seconds · your points are credited instantly',
    },
  },
  buttons: {
    back_to_menu: 'Back to menu',
    back_to_checkout: 'Back to checkout',
    contact_us: 'Contact us {{phone_number}}',
    try_again: 'Try again',
  },
  loading: {
    processing_payment: 'Please do not leave the page while we process your payment',
  },
  success_messages: {
    order_placed: {
      title: '✅ Order successful!',
      description: 'Your order has been placed successfully.',
    },
  },
  error_messages: {
    failed_to_load: 'Order could not be loaded. Please try again.',
    payment_failed: 'Payment failed, please try again',
  },
  load_failed: {
    title: 'We couldn’t load your order',
    description:
      'Something went wrong while loading your order details. Please try again. If it keeps happening, contact support and we will help you right away.',
  },
};
